module.exports = vendors_12b38e694858a5c18e49;